export default {
    CONNECT_VIA_OAUTH: {
        name: 'connectViaOAuth',
            buttonText: 'Connect'
    },
    UPDATE_GOOGLE_ID_CONNECTION: {
        name: 'updateGoogleIdConnection',
            buttonText: 'Update'
    },
    UPDATE_VIA_OAUTH_CONNECTION: {
        name: 'updateViaOAuthConnection',
            buttonText: 'Update'
    }
}
